import { useState, useEffect } from 'react';

const STORAGE_KEY = 'xion-reduced-motion';

export const useReducedMotion = () => {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(() => {
    // Check localStorage first
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored !== null) {
      return stored === 'true';
    }
    // Fall back to system preference
    if (typeof window !== 'undefined') {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
    return false;
  });

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    
    const handleChange = (e) => {
      // Only auto-update if user hasn't manually set preference
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === null) {
        setPrefersReducedMotion(e.matches);
      }
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  const toggleReducedMotion = () => {
    const newValue = !prefersReducedMotion;
    setPrefersReducedMotion(newValue);
    localStorage.setItem(STORAGE_KEY, String(newValue));
  };

  const resetToSystem = () => {
    localStorage.removeItem(STORAGE_KEY);
    const systemPrefers = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    setPrefersReducedMotion(systemPrefers);
  };

  return {
    prefersReducedMotion,
    toggleReducedMotion,
    resetToSystem,
  };
};

export default useReducedMotion;
